import { IAllPrivateRoutes } from "components/routes/app_routes";
import { user } from "config/roles";
import Fidelity from "domains/Fidelity/screens";
import ProgramHistory from "../screens/ProgramHistory";
import Programs from "../screens/Programs";

export const FidelityRoutes: IAllPrivateRoutes[] = [
  { label: "Fidelity", pathName: "/fidelity/advantages", routeElement: Fidelity, roles: user.roles },
  { label: "Programs", pathName: "/fidelity/programs", routeElement: Programs, roles: user.roles },
  { label: "History", pathName: "/fidelity/history", routeElement: ProgramHistory, roles: user.roles },
];
